module.exports = __webpack_public_path__ + "img/gentle2.ce47ff6e.png";